export default {"src":"/_next/static/media/getpacked_Logo_weiss.6466833f.svg","height":43,"width":213};